import { createResult, getAnswer, getQuestions, getResult } from '@/utils/api'

import { createSlice } from '@reduxjs/toolkit'

const questionsSlice = createSlice({
  name: 'questions',
  initialState: {
    questionArray: [],
    isLoading: false,
    isError: false,
    currentQuestion: {},
    isAnswer: false,
    chosenAnswer: {},
    counter: 0,
    result: { id: null, corrects: null, questions: null },
  },
  reducers: {
    startQuiz: state => {
      const [firstQuestion] = state.questionArray

      state.currentQuestion = firstQuestion
    },
    finishQuiz: state => {
      state.currentQuestion = {}
      state.chosenAnswer = {}
      state.questionArray = []
      state.isLoading = false
      state.isError = false
      state.currentQuestion = {}
      state.isAnswer = false
      state.chosenAnswer = {}
      state.counter = 0
    },
    setNextQuestion: (state, action) => {
      state.currentQuestion = state.questionArray[action.payload]
      state.chosenAnswer = {}
      state.isAnswer = false
    },
    setCounter: state => {
      state.counter += 1
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getQuestions.fulfilled, (state, action) => {
        const array = action.payload
        array.map((item, index) => {
          item.index = index + 1
        })
        state.questionArray = array
        state.isLoading = false
        state.isError = false
      })
      .addCase(getQuestions.pending, state => {
        state.questionArray = []
        state.isLoading = true
        state.isError = false
      })
      .addCase(getQuestions.rejected, (state, action) => {
        state.questionArray = []
        state.isLoading = false
        state.isError = true
        console.log(action.error)
      })
      .addCase(getAnswer.fulfilled, (state, action) => {
        state.chosenAnswer = action.payload
        state.isAnswer = true
        state.isLoading = false
        state.isError = false
      })
      .addCase(getAnswer.pending, state => {
        state.chosenAnswer = []
        state.isAnswer = false
        state.isLoading = true
        state.isError = false
      })
      .addCase(getAnswer.rejected, (state, action) => {
        state.chosenAnswer = []
        state.isAnswer = false
        state.isLoading = false
        state.isError = true
        console.log(action.error)
      })
      .addCase(createResult.fulfilled, (state, action) => {
        const result = action.payload

        state.result = {
          corrects: result.corrects,
          id: result.id,
          questions: result.questions,
        }
      })
      .addCase(getResult.fulfilled, (state, action) => {
        if (!state.result.id) {
          const result = action.payload

          state.result = {
            corrects: result.corrects,
            id: result.id,
            questions: result.questions,
          }
        }
      })
  },
})

export const currentQuestionSelector = store => store.questions.currentQuestion

export const currentTextSelector = store => store.questions.currentQuestion.text

export const variantsSelector = store =>
  store.questions.currentQuestion.variants

export const currentNumberSelector = store =>
  store.questions.currentQuestion.index

export const counterSelector = store => store.questions.counter

export const answerSelector = store => store.questions.chosenAnswer

export const answerCheckSelector = store => store.questions.chosenAnswer.right

export const answerMapSelector = store => store.questions.chosenAnswer.mapConfig

export const isAnswerSelector = store => store.questions.isAnswer

export const lengthSelector = store => store.questions.questionArray.length

export const resultSelector = store => store.questions.result

export const isLoadingSelector = store => store.questions.isLoading

export const isErrorSelector = store => store.questions.isError

export const questionReducer = questionsSlice.reducer

export const { startQuiz, finishQuiz, setNextQuestion, setCounter } =
  questionsSlice.actions
